import $marketAxios from "@/services/config/market-axios";

class StakingService {
  getAllPlans(payload) {
    return $marketAxios.post("staking-api/staking-plans/page-query", payload);
  }
  getPublicPlans(payload) {
    return $marketAxios.post(
      "staking-api/public/staking-plans/page-query",
      payload
    );
  }
  getDetailsPlanData(planDetailId) {
    return $marketAxios.get(
      `staking-api/public/staking-plans/detail-by-planDetail-id/v2?planDetailId=${planDetailId}`
    );
  }
  getMyStakingPlans(payload) {
    const { pageNo, pageSize, status } = payload;
    return $marketAxios.get(
      `staking-api/staking-subscription/all?status=${status}&pageNo=${pageNo}&pageSize=${pageSize}`
    );
  }

  getMyStakingPlanDetails(subscriptionId) {
    return $marketAxios.get(
      `staking-api/staking-subscription/detail-by-id?subscriptionId=${subscriptionId}`
    );
  }

  updateRenewalStatus(payload) {
    const { isAutoRenewal, subscriptionId } = payload;
    return $marketAxios.post(
      `staking-api/staking-subscription/update-renewal-status?isAutoRenewal=${+isAutoRenewal}&subscriptionId=${subscriptionId}`
    );
  }

  cancelSubscription(subscriptionId) {
    return $marketAxios.post(
      `staking-api/staking-subscription/cancel?subscriptionId=${subscriptionId}`
    );
  }

  stakePlan(payload) {
    const { planDetailId, stakedAmount, isAutoRenewal } = payload;
    return $marketAxios.post(
      `/staking-api/staking-subscription/stake?planDetailId=${planDetailId}&stakedAmount=${stakedAmount}&isAutoRenewal=${isAutoRenewal}`
    );
  }
  getDisclaimer(subscriptionId) {
    return $marketAxios.get(
      `/staking-api/public/staking-plans/detail/disclaimer?planDetailId=${subscriptionId}`
    );
  }

  getRenewalHistory(subscriptionId) {
    return $marketAxios.post(
      `staking-api/staking-subscription/renewal-history?subscriptionId=${subscriptionId}`
    );
  }
}

export default new StakingService();
